import { Injectable } from '@angular/core';
import { ICwtAuthListener } from '@cawita/core-front/auth';
import { ClientStore } from './client.store';

@Injectable()
export class ClientAuthListener implements ICwtAuthListener {
    constructor(private client: ClientStore) { }
    
    onLogin(user: any): void { this.client.init(user).subscribe(); }
    onLogout(): void { this.client.clear(); }
}